export const proteinsList= [
    'PARP1',
    'PARP1.pADPR',
    'XRCC1',
    'PARG',
    'APE1',
    'APE1(+/-) PCNA',
    'PCNA',
    'PCNA.Ub',
    'APE2',
    'ATR',
    'ATRIP',
    'RPA',
    'Chk1',
    'Chk1.p',
    'RPA2',
    'RPA2.p',
    'RAD17',
    'HUS1',
    'RAD1',
    'RAD9',
    'TopBP1',
    'LIG1',
    'FEN1',
    'Polß',
    'Polδ',
    'Pol ε',
    '53BP1',
    'ATM',
    '53BP1.p',
    'PTIP',
    'Artemis (SNM1C)',
    'Artemis',
    'RIF1',
    'ASF1',
    'REV7',
    'TRIP13',
    'RIF.p',
    'Ku70',
    'Ku80',
    'DNA-PKcs',
    'Artemis.p',
    'SUMO1',
    'XLF',
    'XRCC4',
    'LigaseIV',
    'Pol μ',
    'Pol λ',
    'MRE11',
    'NBS1 (P95)',
    'RAD50',
    'WRN',
    'BLM',
    'BRCA1',
    'CtIP (RBBP8)',
    'RAD51',
    'RAD52',
    'RAD54',
    'FANCN',
    'BRCA2 (FANCD1)',
    'FANCJ (BRIP1/BACH1)',
    'Ccdc98',
    'BRCC36',
    'BRCC45 (BRE/BABAM2)',
    'RAP80',
    'SUMO',
    'SUMO.Ub',
    'RNF4',
    'Ccdc98 (ABRAXAS1/Abra1)',
    'BARD1',
    'BRCA1.p',
    'CtIP',
    'H2AK125',
    'H2AK127',
    'H2AK129',
    'H2AK125U',
    'H2AK127U',
    'H2AK129U',
    'HERC2',
    'BAP1',
    'BAP1.p',
    'Chk2',
    'Chk2.p',
    'ATM.p',
    'H2Ax',
    'γH2Ax',
    'MDC1',
    'MDC1.p',
    'H2A',
    'H2AK13',
    'H2AK15',
    'H2AK13(K27)',
    'H2AK15(K27)',
    'H2AK13(K67)',
    'H2AK15(K67)',
    'Ub K27',
    'Ub K67',
    'RNF168',
    'H1 Histone.Ub',
    'L3MBTL2',
    'RNF8.Ub',
    'UBC13',
    'Mms2',
    'Ring',
    'RNF8',
    'FHA',
    'USP28',
    'USP48',
    'p53',
    'p53.p',
    'p21',
    'GADD45',
    'CIP1',
    'TIP60',
    'Ac.ATM',
    'DSS1',
    'ATR.p'
]
